"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BETAssociationsWrapper;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _immutable = require("immutable");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _filterNot = _interopRequireDefault(require("transmute/filterNot"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

function BETAssociationsWrapper(Component) {
  var BETAssociationWrapper = (0, _createReactClass.default)({
    displayName: 'BETAssociationsWrapper',
    propTypes: {
      BETAssociatedPortalObjects: _propTypes.default.instanceOf(_immutable.List),
      BETAssociatedServiceObjects: _propTypes.default.instanceOf(_immutable.List),
      onBETAssociationChange: _propTypes.default.func
    },
    getDefaultProps: function getDefaultProps() {
      return {
        onBETAssociationChange: function onBETAssociationChange() {
          return _emptyFunction.default;
        }
      };
    },
    getInitialState: function getInitialState() {
      return {
        BETPortalAssociations: null,
        BETServiceAssociations: null
      };
    },
    getBETAssociations: function getBETAssociations(associationType) {
      var _this$state = this.state,
          BETPortalAssociations = _this$state.BETPortalAssociations,
          BETServiceAssociations = _this$state.BETServiceAssociations;
      var _this$props = this.props,
          BETAssociatedPortalObjects = _this$props.BETAssociatedPortalObjects,
          BETAssociatedServiceObjects = _this$props.BETAssociatedServiceObjects;
      return {
        BETPortalAssociations: BETPortalAssociations || BETAssociatedPortalObjects,
        BETServiceAssociations: BETServiceAssociations || BETAssociatedServiceObjects
      }[associationType];
    },
    onAddAssociation: function onAddAssociation(associationType) {
      var _this = this;

      return function (value) {
        var associations = _this.getBETAssociations(associationType);

        var newAssociations = associations.push(value);

        _this.setState((0, _defineProperty2.default)({}, associationType, associations.push(value)));

        _this.props.onBETAssociationChange(associationType)(newAssociations);
      };
    },
    onRemoveAssociation: function onRemoveAssociation(associationType) {
      var _this2 = this;

      return function (value) {
        var associations = _this2.getBETAssociations(associationType);

        var newAssociations = (0, _filterNot.default)(function (association) {
          return association.equals(value);
        }, associations);

        _this2.setState((0, _defineProperty2.default)({}, associationType, newAssociations));

        _this2.props.onBETAssociationChange(associationType)(newAssociations);
      };
    },
    getComponentProps: function getComponentProps() {
      return (0, _omit.default)(['onBETAssociationChange', 'BETAssociatedPortalObjects', 'BETAssociatedServiceObjects'], this.props);
    },
    getBETProps: function getBETProps() {
      var betProps = {};

      if (_ScopesContainer.default.isScoped('bet-deliverable-service-association-access')) {
        betProps.BETServiceAssociations = this.getBETAssociations('BETServiceAssociations');
      }

      if (_ScopesContainer.default.isScoped('bet-portal-association-access')) {
        betProps.BETPortalAssociations = this.getBETAssociations('BETPortalAssociations');
      }

      if (Object.keys(betProps).length) {
        betProps.onAddBETAssociation = this.onAddAssociation;
        betProps.onRemoveBETAssociation = this.onRemoveAssociation;
      }

      return betProps;
    },
    render: function render() {
      return _react.default.createElement(Component, (0, _extends2.default)({}, this.getBETProps(), this.getComponentProps()));
    }
  });
  return BETAssociationWrapper;
}

module.exports = exports.default;